<template>
  <!--
    @name: LoginDialog.vue
    @description:
    @author:  GaoYu
    @time: 2020/7/30 13:29
  -->
  <van-overlay class="login-dialog" :show="loginDialogShow" z-index="2017">
    <van-form @submit="login">
      <div class="form-title">请先登录</div>
      <div class="mobile-ipt">
        <van-field
          v-model="loginForm.mobile"
          placeholder="手机号"
        />
      </div>
      <div class="code-ipt">
        <van-field
          v-model="loginForm.code"
          type="code"
          maxlength="6"
          placeholder="验证码"
        />
        <van-button class="send-code-btn" type="default" size="mini" @click="sendCode" :disabled="isSendCode"
                    v-if="isSendCode===false">获取验证码
        </van-button>
        <van-button class="send-code-btn" type="default" size="mini" :disabled="isSendCode" v-if="isSendCode===true">
          {{loginCodeTime}}s后重新获取
        </van-button>
      </div>
      <van-button class="submit-btn" type="primary" @click="login">确定</van-button>
    </van-form>
  </van-overlay>

</template>

<script>
import aes from '../../utils/aes'
import auth from '../../utils/auth'
import { liveIsNeedAppointApi } from '@/api/live'
import { smsCodeApi, loginOrRegApi, getWechatInfoByCodeApi, bindWecahtApi } from '@/api/sys'
export default {
  name: 'LoginDialog',
  data () {
    return {
      liveId: this.$route.params.live_id,
      appId: 'wx4c0a666cc25aa3c5',
      loginDialogShow: false,
      loginForm: {
        area_code: '86',
        mobile: '',
        code: ''
      },
      isSendCode: false,
      loginCodeTime: 60
    }
  },
  computed: {
    isWechatOpen () {
      let u = navigator.userAgent
      if (/MicroMessenger/gi.test(u)) {
        return true
      }
      return false
    }
  },
  mounted () {
  },
  methods: {
    liveBefore (activeUrl) {
      // 活动不存在 nothing
      if (activeUrl === '') {
        return false
      }
      // 有用户 identify 判断是否玩过改活动
      let identify = auth.getIdentify()
      if (identify) {
        this.isJump(identify)
        return false
      }
      // 微信授权了,获得用户信息
      if (this.$route.query.code) {
        getWechatInfoByCodeApi({
          code: this.$route.query.code,
          appid: this.appId
        }).then(res => {
          if (res.code !== this.$config.codeOk) { // 通过微信没有获取到数据，直接显示手机号登录
            this.loginDialogShow = true
            return false
          }
          // 有账号，直接登录
          if (res.data.is_account === 1 && res.data.identify !== '') {
            // 记录登录信息
            auth.setIdentify(res.data.identify)
            this.isJump(res.data.identify)
            return false
          }
          // 没有账号, 记录微信信息之后登录
          window.sessionStorage.setItem('wechatInfo', JSON.stringify(res.data.wechat_info))
          this.loginDialogShow = true
        })
      } else { // 去登陆
        this.startLogin()
      }
    },
    startLogin () {
      // 直接登录
      if (!this.isWechatOpen) {
        this.loginDialogShow = true
        return false
      }
      // 微信授权
      let redirectUri = 'https://www.dianyuan.com/wechat.php'
      let state = auth.getWxState(window.location.href) // 下划线前面是名片id后面是活动id
      let strUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.appId +
        '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=' + state + '#wechat_redirect'
      window.location.href = strUrl
    },
    sendCode () {
      if (!this.loginForm.mobile) {
        this.$toast('请输入手机号')
        return false
      }
      smsCodeApi({
        mobile: aes.aesEncrypt(this.loginForm.mobile),
        area_code: this.loginForm.area_code,
        way: 'login'
      }).then((res) => {
        if (res.code !== this.$config.codeOk) {
          this.$toast(res.msg)
        } else {
          this.timer()
        }
      })
    },
    timer () {
      this.isSendCode = true
      if (this.loginCodeTime > 0) {
        this.loginCodeTime--
        setTimeout(this.timer, 1000)
      } else {
        this.loginCodeTime = 60
        this.isSendCode = false
      }
    },
    login () {
      if (!this.loginForm.mobile) {
        this.$toast('请输入手机号')
        return false
      }
      loginOrRegApi({
        type: 3,
        area_code: this.loginForm.area_code,
        account: aes.aesEncrypt(this.loginForm.mobile),
        credential: aes.aesEncrypt(this.loginForm.code),
        autologin: 1
      }).then(res => {
        if (res.code !== this.$config.codeOk) {
          this.$toast(res.msg)
          return false
        }
        auth.setIdentify(res.data.identify)
        auth.setToken(res.data.access_token)
        let wechatInfo = window.sessionStorage.getItem('wechatInfo')
        if (wechatInfo) {
          // 有微信信息，绑定微信
          wechatInfo = JSON.parse(wechatInfo)
          bindWecahtApi(wechatInfo).then(res => {
          })
        }
        this.liveBefore()
      })
    },
    isJump (identify) {
      liveIsNeedAppointApi({
        live_id: this.liveId,
        identify: identify
      }).then(res => {
        console.log(res)
        if (res.code === this.$config.codeOk) {
          if (res.data.url !== '') {
            window.location.href = res.data.url
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .login-dialog {
    .van-form {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 300px;
      height: 253px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 10px 11px 0px rgba(141, 139, 139, 0.5);
      border-radius: 5px;
      padding: 20px;

      .form-title {
        width: 100%;
        text-align: center;
        height: 24px;
        font-size: 17px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 24px;
        margin-bottom: 25px;
      }

      .van-cell {
        width: 100%;
        background: rgba(255, 255, 255, 1);
        border-radius: 5px;
        border: 1px solid rgba(221, 221, 221, 1);
        margin-bottom: 15px;
      }

      .submit-btn {
        width: 100%;
        height: 40px;
        background: rgba(117, 58, 183, 1);
        border-radius: 5px;
        border: none;
      }
    }

    .code-ipt {
      position: relative;

      .send-code-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        height: 24px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(117, 58, 183, 1);
        line-height: 24px;
        border: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginDialog.vue